export default __webpack_public_path__ + "static/media/panTech.ba8a304c.png";